import { Component } from '@angular/core';
import {YandexMapComponent} from '../../../../elements/yandex-map/yandex-map.component';

@Component({
  selector: 'app-place-section',
  imports: [
    YandexMapComponent
  ],
  templateUrl: './place-section.component.html',
  styleUrl: './place-section.component.scss'
})
export class PlaceSectionComponent {

}
